import React from 'react';
import { css } from '@compiled/react';

import { token } from '@atlaskit/tokens';

import { PersistentInvitePeopleButton } from '@confluence/persistent-invite-button/entry-points/PersistentInvitePeopleButton.ts';

import { NAV_COLLAPSE_BREAKPOINT_PX } from '../layoutConstants.ts';

const persistentInvitePeopleButtonLayoutStyles = css({
	marginTop: 'auto',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'.persistent-invite-button-container': {
		marginBottom: token('space.400'),
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'.persistent-invite-icon-button': {
		display: 'none',
		padding: token('space.050'),
		width: '100%',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'.persistent-invite-button': {
		display: 'block',
		padding: '0px',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
	[`@media (max-width: var(--media-max-width)px)`]: {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
		'.persistent-invite-icon-button': {
			display: 'block',
		},
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
		'.persistent-invite-button': {
			display: 'none',
		},
	},
});

export function PersistentInvitePeopleButtonContainer({
	rightSidebarCompensation,
}: {
	rightSidebarCompensation: number;
}) {
	return (
		<div
			css={persistentInvitePeopleButtonLayoutStyles}
			style={
				{
					// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
					'--media-max-width': `${NAV_COLLAPSE_BREAKPOINT_PX + rightSidebarCompensation}px`,
				} as React.CSSProperties
			}
		>
			<PersistentInvitePeopleButton source="homeScreen" hasIconButton />
		</div>
	);
}
